module.exports = __webpack_public_path__ + "img/98.5ec610c7.jpg";